import axios from "axios";
import {
  LIST_CLINIC_VISITS_FAIL,
  LIST_CLINIC_VISITS_REQUEST,
  LIST_CLINIC_VISITS_SUCCESS,
  LIST_PATIENT_VISITS_FAIL,
  LIST_PATIENT_VISITS_REQUEST,
  LIST_PATIENT_VISITS_SUCCESS,
  VISIT_CREATE_FAIL,
  VISIT_CREATE_REQUEST,
  VISIT_CREATE_SUCCESS,
  VISIT_SCAN_UPDATE_FAIL,
  VISIT_SCAN_UPDATE_REQUEST,
  VISIT_SCAN_UPDATE_SUCCESS,
} from "../constants/visitConstants";

import { logout } from "./userActions";

export const createVisit = (newVisit) => async (dispatch, getState) => {
  try {
    dispatch({
      type: VISIT_CREATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(`/api/visits`, newVisit, config);

    dispatch({
      type: VISIT_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: VISIT_CREATE_FAIL,
      payload: message,
    });
  }
};

export const listPatientVisits = (patientId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LIST_PATIENT_VISITS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(
      `/api/visits/${patientId}/patient`,
      config,
    );

    dispatch({
      type: LIST_PATIENT_VISITS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: LIST_PATIENT_VISITS_FAIL,
      payload: message,
    });
  }
};

export const listClinicVisits = (inputs) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LIST_CLINIC_VISITS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(
      `/api/visits/${inputs.clinicId}/clinic?reqDate=${inputs.reqDate}&startDate=${inputs.startDate}&endDate=${inputs.endDate}&searchTitleId=${inputs.searchTitleId}`,
      config,
    );

    dispatch({
      type: LIST_CLINIC_VISITS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: LIST_CLINIC_VISITS_FAIL,
      payload: message,
    });
  }
};

export const getVisitDetails = async ({
  visitId,
  userInfo,
  dispatch,
  setErrorVisit,
}) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/visits/${visitId}`, config);
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message;

    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    } else {
      setErrorVisit(message);
    }

    return null; // prevent undefined explosions
  }
};

export const updateVisitScans =
  ({ visitId, visitScans }) =>
  async (dispatch, getState) => {
    // update physician note action
    try {
      dispatch({
        type: VISIT_SCAN_UPDATE_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/visits/${visitId}/visitScans`,
        { visitScans },
        config,
      );

      dispatch({
        type: VISIT_SCAN_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error);
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      if (message === "Not authorized, token failed") {
        dispatch(logout());
      } else {
        dispatch({
          type: VISIT_SCAN_UPDATE_FAIL,
          payload: message,
        });
      }
    }
  };
